"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetErrorToJSON = exports.AssetErrorFromJSONTyped = exports.AssetErrorFromJSON = exports.AssetError = void 0;
/**
 * Asset error state if one exists.
 * @export
 */
exports.AssetError = {
    AssetErrorUnset: 'ASSET_ERROR_UNSET',
    ProjectDisposedErr: 'PROJECT_DISPOSED_ERR',
    ScriptRevisionRejected: 'SCRIPT_REVISION_REJECTED',
    AudioRevisionRejected: 'AUDIO_REVISION_REJECTED',
    ProjectRejected: 'PROJECT_REJECTED',
    Unrecognized: 'UNRECOGNIZED'
};
function AssetErrorFromJSON(json) {
    return AssetErrorFromJSONTyped(json, false);
}
exports.AssetErrorFromJSON = AssetErrorFromJSON;
function AssetErrorFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AssetErrorFromJSONTyped = AssetErrorFromJSONTyped;
function AssetErrorToJSON(value) {
    return value;
}
exports.AssetErrorToJSON = AssetErrorToJSON;
